import { API_REQUEST } from '../../../../store/sagas/api';
import { getPreviousLessonToWatch, getSpecificLessonToWatch } from '../../../../backend-api';
import { LOAD_LESSON_TO_WATCH, LOAD_LESSON_TO_WATCH_FAILED, LOAD_LESSON_TO_WATCH_SUCCESS } from './action-types';

export const loadPreviousLessonToWatch = courseId => ({
  type: API_REQUEST,
  types: [LOAD_LESSON_TO_WATCH, LOAD_LESSON_TO_WATCH_SUCCESS, LOAD_LESSON_TO_WATCH_FAILED],
  call: () => getPreviousLessonToWatch(courseId),
});

export const loadSpecificLessonToWatch = (courseId, lessonId) => ({
  type: API_REQUEST,
  types: [LOAD_LESSON_TO_WATCH, LOAD_LESSON_TO_WATCH_SUCCESS, LOAD_LESSON_TO_WATCH_FAILED],
  call: () => getSpecificLessonToWatch(courseId, lessonId),
});
